import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "olive-react-myoneui/lib/Button";
import { Badge } from "olive-react-myoneui";
import { pluralize } from '../../../../helpers/string_helper';

function EventActivitySlot({ 
  className, 
  thumbnailEvent,
  title, 
  lectureCount, 
  eventDates, 
  eventTimeSlot,
  status, 
  venue,
  link,
  type,
  countCourses,
  countEvents,
  countTrainingCourses,
  sessionDate,
  isSessionExpired,
  sessionLocation,
  isOnline,
  platform,
  defaultImg,
  isRestrictionFlagged,
  restrictionActivity,
  isAttended
}) {
  const navigate = useNavigate();

  const isExternalLink = (url) => {
    try {
        const linkUrl = new URL(url);
        return linkUrl.protocol === "http:" || linkUrl.protocol === "https:";
    } catch (e) {
        return false;
    }
  };

  const clickHandler = (e) => {
    if (link) {
      if (isExternalLink(link)) {
          window.open(link, "_blank");
      } else {
          navigate(link);
      }
    }
  };

  return (
    <>
      <div className={`${className || ''} myk__stu-event_schedule-wrapper`}>
        <div className="event-schedule-content">
          <div className="event-title">
            <div className="event-img-wrapper">
              <img src={thumbnailEvent} onError={(e) => (e.target.src = defaultImg)} alt="Event Image" className="img-fluid" />
            </div>
            <div className="pe-2">
              <h1>{title || 'No Title'}</h1>
              {type === 'session' && !isOnline && (
                <div className="lecture-venue d-flex align-items-center gap-2">
                  <p>Venue:</p>
                  <h3>{venue}</h3>
                </div>
              )}
              {type === 'session' && isOnline && platform !== '' && (
                <div className="lecture-venue d-flex align-items-center gap-2">
                  <p>Platform:</p>
                  <h3>{platform}</h3>
                </div>
              )}
            </div>

            {lectureCount > 0 ? (
              <div className="lecture-count">
                <p>No. of Lectures</p>
                <h1>{lectureCount}</h1>
              </div>
            ) : ('')}

            {type === 'Bundle' ? (
              <div className="lecture-count">
                <p>Bundle</p>
                <h1>{pluralize(countCourses, 'Course', true)} {pluralize(countTrainingCourses, 'Training Course', true)} {pluralize(countEvents, 'Event', true)}</h1>
              </div>
            ) : ('')}

            {type !== 'session' && isRestrictionFlagged && (
              <div className="event-venue-date">
                <p>Accesss Restriction Enabled</p>
                <h2>{restrictionActivity?.restrictionLabel + ': '} </h2>
                <h2>{restrictionActivity?.restrictionDate}</h2>
              </div>
            )}

            {eventDates && (
              <div className="event-venue-date">
                <p>Dates</p>
                <h2>{type === 'session' ? sessionDate : eventDates}</h2>
                <h2>{eventTimeSlot}</h2>
              </div>
            )}

            <div className="lecture-count myk__stu-event_session-action flex-none">
              {isSessionExpired === 0 && status === 'not-started' && (
                <Button variant="primary" className="btn-sm btn-round" onClick={clickHandler} disabled={isRestrictionFlagged && restrictionActivity && restrictionActivity?.isStartBtnEnable == false ? true : false}>Start</Button>
              )}
              {isSessionExpired === 0 && status === 'start' && isOnline && (
                <Button variant="primary" className="btn-sm btn-round" onClick={clickHandler}>Start</Button>
              )}
              {isSessionExpired === 0 && status === 'inprogress' && (
                <Button variant="secondary" className="btn-sm btn-round" onClick={clickHandler}>In Progress</Button>
              )}
              {(type !== 'session' && isSessionExpired === 1 && status === 'not-started') || 
               (type !== 'session' && isSessionExpired === 1 && status === 'inprogress')  || 
               (type !== 'session' && isSessionExpired === 1 && status === 'start') ? (
                <Button variant="danger" className="btn-sm btn-round text-white bg-danger" onClick={clickHandler}>Incomplete</Button>
              ) : (
                ''
              )}
              {(type !== 'session' && isSessionExpired === 1 && status === 'completed') && (
                <Button variant="primary" className="btn-sm btn-round">Completed</Button>
              )}
              {(type !== 'session' && isSessionExpired === 0 && status === 'completed') && (
                <Button variant="primary" className="btn-sm btn-round">Completed</Button>
              )}
              {type === 'session' && isSessionExpired === 1 && isAttended && isOnline && (
                <Badge variant="success">Completed</Badge>
              )}
              {type === 'session' && isSessionExpired === 1 && !isAttended && isOnline && (
                <Badge variant="danger" className="text-white bg-danger">Incomplete</Badge>
              )}
              {type === 'session' && isSessionExpired === 1 && !isOnline && (
                <Badge variant="success">Completed</Badge>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EventActivitySlot;
